/**
 * Erro que o Auth0 devolve no re-render da screen depois do POST do SDK:
 * `login()` submete um form e a página recarrega com `transaction.errors`,
 * nunca com uma exceção no browser. Reduz a um código da UI sem repassar a
 * mensagem do provedor (que pode citar detalhes da conta).
 */
export type TransactionErrorLike = { code?: string; message?: string }

export type TransactionErrorCode = 'CAPTCHA_REQUIRED' | 'FAILED'

export function toTransactionErrorCode(
  errors: TransactionErrorLike[] | null | undefined,
): TransactionErrorCode | undefined {
  if (!errors?.length) return undefined
  const captcha = errors.some((e) => /captcha/i.test(`${e.code ?? ''} ${e.message ?? ''}`))
  return captcha ? 'CAPTCHA_REQUIRED' : 'FAILED'
}

/** Código vindo do hook vira a copy da tela; mensagem já em pt-BR passa direto. */
export function errorCopy(
  error: string | undefined,
  copy: Record<string, string>,
): string | undefined {
  if (!error) return undefined
  return copy[error] ?? error
}
